export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13809.43b4d15c.jpg";